/* ============================================================
   SPRING LP - JavaScript
   Drop this file into: assets/spring-lp.js
   Bundle auto-add lives in snippets/spring-bundle-autoadd.liquid
   This file handles: smooth scroll, optional countdown timer.
   ============================================================ */

// ---- SMOOTH SCROLL ----
document.addEventListener('click', function (e) {
  var target = e.target.closest('a[href^="#"]');
  if (!target) return;
  var hash = target.getAttribute('href');
  if (!hash || hash === '#') return;
  var el = document.querySelector(hash);
  if (!el) return;
  e.preventDefault();
  el.scrollIntoView({ behavior: 'smooth', block: 'start' });
});

// ---- OPTIONAL COUNTDOWN TIMER ----
// Add a <span class="slp-countdown" data-end-date="2026-05-03T23:59:59-04:00"></span>
// to any LP element to render a live countdown.

(function () {
  'use strict';
  var nodes = document.querySelectorAll('.slp-countdown');
  if (!nodes.length) return;

  function tick() {
    var now = Date.now();
    nodes.forEach(function (node) {
      var endStr = node.getAttribute('data-end-date');
      if (!endStr) return;
      var end = Date.parse(endStr);
      var ms = end - now;
      if (ms <= 0) {
        node.textContent = 'Ended';
        return;
      }
      var d = Math.floor(ms / (1000 * 60 * 60 * 24));
      var h = Math.floor((ms % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var m = Math.floor((ms % (1000 * 60 * 60)) / (1000 * 60));
      node.textContent = d + 'd ' + h + 'h ' + m + 'm';
    });
  }
  tick();
  setInterval(tick, 60000);
})();
